import type { Promotion, Subscription } from '../../../types';

function getDiscountedPriceCents(data: any) {
  return data?.promotions
    ?.filter(({ promotion }: Promotion) => promotion?.is_recurring)
    ?.sort((a: Promotion, b: Promotion) => a.discounted_price_cents - b.discounted_price_cents)?.[0]
    ?.discounted_price_cents;
}

function getUpgradeDowngradeOptions(data: any) {
  if (
    !data?.upgrade_downgrade_options?.hour_change_options &&
    !data?.upgrade_downgrade_options?.plan_change_options
  ) {
    return undefined;
  }

  return {
    hour_change_options:
      data?.upgrade_downgrade_options?.hour_change_options?.map(processOption) || [],
    plan_change_options:
      data?.upgrade_downgrade_options?.plan_change_options?.map(processOption) || [],
  };
}

function processOption(option: any) {
  return {
    ...option,
    is_contract: option?.contract?.duration_periods !== 1,
  };
}

function select(data: any): Subscription {
  return {
    ...data,
    discounted_price_cents: getDiscountedPriceCents(data),
    is_contract: data.contract?.duration_periods !== 1,
    pending_transformation: data.scheduled_transformations?.find(
      (transformation: any) => !transformation.deleted_at && !transformation.executed_at
    ),
    upgrade_downgrade_options: getUpgradeDowngradeOptions(data),
  };
}

export default select;
